import { Flex } from "@redotech/redo-web/flex";
import { Text } from "@redotech/redo-web/text";
export function PortalDisabled({ color }: { color: string }) {
  return (
    <Flex color={color}>
      <Text> Redo will be available very soon. Please stay tuned.</Text>
    </Flex>
  );
}
